var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    staticClass: "px-1",
    attrs: {
      "max-width": "1024px",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "headline text-start mt-8"
  }, [_vm.user._id ? _c('span', [_vm._v("회원 상세보기")]) : _c('span', [_vm._v("회원 등록")])]), _c('v-card', {
    staticClass: "my-4"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-card-subtitle', {
    staticClass: "font-weight-bold grey lighten-4"
  }, [_vm._v("계정")]), _c('v-divider'), _c('v-row', {
    staticClass: "mx-1 my-4"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "아이디",
      "persistent-placeholder": "",
      "hide-details": "",
      "readonly": ""
    },
    model: {
      value: _vm.user.username,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "username", $$v);
      },
      expression: "user.username"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  })], 1), _c('v-row', {
    staticClass: "mx-1 my-4"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "비밀번호",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.password,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "password", $$v);
      },
      expression: "user.password"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  })], 1), _c('v-divider'), _c('v-card-subtitle', {
    staticClass: "font-weight-bold grey lighten-4"
  }, [_vm._v("기본 정보")]), _c('v-divider'), _vm.user.type == _vm.PERSON.value ? [_c('v-row', {
    staticClass: "mx-1 my-4"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "이름",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.name,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "name", $$v);
      },
      expression: "user.name"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "date",
      "label": "생년월일",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.bornAt,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "bornAt", $$v);
      },
      expression: "user.bornAt"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mx-1 my-4"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "성별",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.sex,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "sex", $$v);
      },
      expression: "user.sex"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "국가",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.nation,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "nation", $$v);
      },
      expression: "user.nation"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mx-1 my-4"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "직업",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.occupation,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "occupation", $$v);
      },
      expression: "user.occupation"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "직장",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.companyName,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "companyName", $$v);
      },
      expression: "user.companyName"
    }
  })], 1)], 1)] : _vm._e(), _vm.user.type == _vm.COMPANY.value ? [_c('v-row', {
    staticClass: "mx-1 my-4"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "기업명",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.name,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "name", $$v);
      },
      expression: "user.name"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "date",
      "label": "기업설립일",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.foundAt,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "foundAt", $$v);
      },
      expression: "user.foundAt"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mx-1 my-4"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "사업자등록번호",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.businessRegisitrationNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "businessRegisitrationNumber", $$v);
      },
      expression: "user.businessRegisitrationNumber"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "국가",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.nation,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "nation", $$v);
      },
      expression: "user.nation"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mx-1 my-4"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "대표자명",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.ceoName,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "ceoName", $$v);
      },
      expression: "user.ceoName"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "홈페이지주소",
      "persistent-placeholder": "",
      "hide-details": "",
      "append-icon": "mdi-link"
    },
    on: {
      "click:append": function clickAppend($event) {
        return _vm.window.open(_vm.user.website, '_blank');
      }
    },
    model: {
      value: _vm.user.website,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "website", $$v);
      },
      expression: "user.website"
    }
  })], 1)], 1)] : _vm._e(), _c('v-divider'), _c('v-card-subtitle', {
    staticClass: "font-weight-bold grey lighten-4"
  }, [_vm._v("연락처")]), _c('v-divider'), _c('v-row', {
    staticClass: "mx-1 my-4"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "연락처",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "phone", $$v);
      },
      expression: "user.phone"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "이메일",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.email,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "email", $$v);
      },
      expression: "user.email"
    }
  })], 1)], 1), _c('v-divider'), _c('v-row', {
    staticClass: "mx-1 my-4"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "우편번호",
      "persistent-placeholder": "",
      "hide-details": "",
      "readonly": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.DaumPostcode.open();
      }
    },
    model: {
      value: _vm.user.postcode,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "postcode", $$v);
      },
      expression: "user.postcode"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mx-1 my-4"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "기본주소",
      "persistent-placeholder": "",
      "hide-details": "",
      "readonly": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.DaumPostcode.open();
      }
    },
    model: {
      value: _vm.user.address1,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "address1", $$v);
      },
      expression: "user.address1"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "상세주소",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.address2,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "address2", $$v);
      },
      expression: "user.address2"
    }
  })], 1)], 1), _vm.user.type == _vm.COMPANY.value ? [_c('v-divider'), _c('v-card-subtitle', {
    staticClass: "font-weight-bold grey lighten-4"
  }, [_vm._v("담당자 정보")]), _c('v-divider'), _c('v-row', {
    staticClass: "mx-1 my-4"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "이름",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.workerName,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "workerName", $$v);
      },
      expression: "user.workerName"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "연락처",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.workerPhone,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "workerPhone", $$v);
      },
      expression: "user.workerPhone"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "이메일",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.workerEmail,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "workerEmail", $$v);
      },
      expression: "user.workerEmail"
    }
  })], 1)], 1)] : _vm._e()], 2), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-divider', {
    staticClass: "d-none d-md-block",
    attrs: {
      "vertical": ""
    }
  }), _c('v-divider', {
    staticClass: "d-block d-md-none"
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-card-subtitle', {
    staticClass: "font-weight-bold grey lighten-4"
  }, [_vm._v("정보수신방법")]), _c('v-divider'), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers_notify,
      "items": _vm.user.notify,
      "disable-sort": "",
      "hide-default-footer": "",
      "mobile-breakpoint": "20000"
    },
    scopedSlots: _vm._u([_vm._l(_vm.headers_notify.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header) {
      return {
        key: "item.".concat(header.value),
        fn: function fn(_ref) {
          var value = _ref.value;
          return [_vm._v(" " + _vm._s(header.formatter(value)) + " ")];
        }
      };
    })], null, true)
  }), _c('v-divider'), _c('v-card-subtitle', {
    staticClass: "font-weight-bold grey lighten-4"
  }, [_vm._v("관리자메모")]), _c('v-divider'), _c('v-card-text', [_vm.user.type == _vm.COMPANY.value ? _c('v-textarea', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "hide-details": "",
      "rows": "12",
      "auto-grow": ""
    },
    model: {
      value: _vm.user.note,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "note", $$v);
      },
      expression: "user.note"
    }
  }) : _vm._e(), _vm.user.type == _vm.PERSON.value ? _c('v-textarea', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "hide-details": "",
      "rows": "7",
      "auto-grow": ""
    },
    model: {
      value: _vm.user.note,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "note", $$v);
      },
      expression: "user.note"
    }
  }) : _vm._e()], 1)], 1)], 1), _c('v-divider'), _c('v-card-actions', {
    staticClass: "align-center grey lighten-4"
  }, [_c('v-switch', {
    staticClass: "my-0 mx-4 pa-0",
    attrs: {
      "color": "red lighten-1",
      "dense": "",
      "inset": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.isWarning,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "isWarning", $$v);
      },
      expression: "user.isWarning"
    }
  }, [_c('span', {
    staticClass: "subtitle-2 font-weight-bold",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(" 주의회원 ")])]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")]), _c('user-withdraw', {
    on: {
      "input": function input($event) {
        return _vm.$router.go(-1);
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var attrs = _ref2.attrs,
            on = _ref2.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-2",
          attrs: {
            "color": "red darken-1",
            "dark": ""
          }
        }, 'v-btn', attrs, false), on), [_vm._v("탈퇴")])];
      }
    }]),
    model: {
      value: _vm.user,
      callback: function callback($$v) {
        _vm.user = $$v;
      },
      expression: "user"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mx-1 my-4",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "auto",
      "sm": "auto"
    }
  })], 1)], 1), _c('daum-postcode', {
    ref: "DaumPostcode",
    on: {
      "input": _vm.setAddress
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }